<template>
	<div class="image-loader">
		<div v-if="loading" class="skeleton">
			<div class="skeleton-gradient"></div>
		</div>
		<img
			v-show="!loading"
			class="img-fluid"
			:src="src"
			:alt="alt"
			@load="onLoad"
			@error="onError" />
	</div>
</template>

<script setup>
	import { ref } from "vue"

	const props = defineProps({
		src: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			default: "image",
		},
	})

	const loading = ref(true)

	const onLoad = () => {
		loading.value = false
	}

	const onError = () => {
		loading.value = false
	}
</script>

<style lang="less">
	.image-loader {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			display: block;
			max-width: 100%;
			height: auto;
		}

		.skeleton {
			width: 100%;
			height: 100%;
			padding-top: 56.25%; /* Maintain aspect ratio (e.g., 16:9) */
			background-color: #e0e0e0;
			position: relative;
			overflow: hidden;
		}

		.skeleton-gradient {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(
				90deg,
				rgba(224, 224, 224, 0) 0%,
				rgba(200, 200, 200, 0.8) 50%,
				rgba(224, 224, 224, 0) 100%
			);
			animation: loading 2s infinite;
		}

		@keyframes loading {
			0% {
				transform: translateX(-100%);
			}
			100% {
				transform: translateX(100%);
			}
		}
	}
</style>
